var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversa-history"},[_c('iframe',{attrs:{"src":_vm.conversaUrl,"width":"100%","height":"600","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }